<template>
  <div class="card bg-white border-0 rounded-3 mb-4">
    <div class="card-body p-4">
      <form @submit.prevent="validateForm">
        <div class="row">
          <div class="col-lg-4 col-sm-6">
            <div class="form-group mb-4" >
              <label class="label text-secondary">Torneo</label>
              <select 
                class="form-select form-control h-45"
                aria-label="Default select example"
                v-model="play.tournamentId" 
                @click="getMatchesByTournament()"
                @change="clearError('tournamentId')"
                
              >
                <option :value="null">-- Seleccionar --</option>
                <option :value="tourney.id" v-for="(tourney, i) of itemsTournament"  :key="i" >{{tourney.name}}</option> 
              </select>
              <div class="input-error">{{ errors.tournamentId }}</div>
            </div>
          </div>
          <div class="col-lg-4 col-sm-6">
            <div class="form-group mb-4" >
              <label class="label text-secondary">Partido</label>
              <select 
                class="form-select form-control h-45"
                aria-label="Default select example"
                v-model="play.matchId" 
                @change="clearError('matchId')"
              >
                <option :value="null">-- Seleccionar --</option>
                <option :value="item.id" v-for="(item, i) of itemsMatch"  :key="i" >{{item.name}}</option> 
              </select>
              <div class="input-error">{{ errors.matchId }}</div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-4 col-sm-6">
            <div class="form-group mb-4">
              <label class="label text-secondary">Nombre</label>
              <input
                type="text"
                class="form-control h-45"
                placeholder="Ingresar el nombre de la Jugada"
                v-model="play.name"
                @input="clearError('name')"
              />
              <div v-if="errors.name"  class="input-error">{{ errors.name }}</div> 
            </div>
          </div>
          <div class="col-lg-2 col-sm-6">
            <div class="form-group mb-4">
              <label class="label text-secondary">Fecha Inicio</label>
              <VueDatePicker placeholder="Fecha y hora"
                  v-model="play.startDate" 
                  format="dd/MM/yyyy HH:mm" 
                  :format-locale="es" 
                  @input="clearError('startDate')" 
                  :minutes-increment="30"
                  :enable-time-picker="true"
                  is-24
                  teleport 
              />
              <div class="input-error">{{ errors.startDate }}</div>
            </div>
          </div>
          <div class="col-lg-2 col-sm-6">
            <div class="form-group mb-4">
              <label class="label text-secondary">Fecha Fin</label>
              <VueDatePicker placeholder="Fecha y hora"
                v-model="play.endDate" 
                format="dd/MM/yyyy HH:mm" 
                :format-locale="es"
                @input="clearError('endDate')" 
                :minutes-increment="30" 
                is-24
                teleport 
              />
              <div class="input-error">{{ errors.endDate }}</div>
            </div>
          </div>
          <div class="row">
            <div class="col-lg-4 col-sm-6">
              <div class="form-group mb-4"  >
                <label class="label text-secondary">Título</label>
                <input
                  type="text"
                  class="form-control h-45"
                  placeholder="Ingresar el título de la jugada"
                  v-model="play.title"
                  @input="clearError('title')"
                />
                <div class="input-error">{{ errors.title }}</div>
              </div>
            </div>
            <div class="col-lg-4 col-sm-6">
              <div class="form-group mb-4"  >
                <label class="label text-secondary">Subtítulo</label>
                <input
                  type="text"
                  class="form-control h-45"
                  placeholder="Ingresar el subtítulo de la jugada"
                  v-model="play.subtitle"
                  @input="clearError('subtitle')"
                />
                <div class="input-error">{{ errors.subtitle }}</div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-lg-4 col-sm-6">
              <div class="form-group mb-4"  >
                <label class="label text-secondary">Kickoff Título</label>
                <input
                  type="text"
                  class="form-control h-45"
                  placeholder="Ingresar el título Kickoff"
                  v-model="play.kickoffTitle"
                  @input="clearError('kickoffTitle')"
                />
                <div class="input-error">{{ errors.kickoffTitle }}</div>
              </div>
            </div>
            <div class="col-lg-4 col-sm-6">
              <div class="form-group mb-4"  >
                <label class="label text-secondary">Kickoff Descripción</label>
                <input
                  type="text"
                  class="form-control h-45"
                  placeholder="Ingresar la descripción del Kickoff"
                  v-model="play.kickoffDescription"
                  @input="clearError('kickoffDescription')"
                />
                <div class="input-error">{{ errors.kickoffDescription }}</div>
              </div>
            </div>
          </div>
          <div class="col-lg-12">
            <div class="form-group mb-4">
              <label class="label text-secondary">Portada</label>
              <div v-if="play.urlCoverPhoto">
                <img  :src="play.urlCoverPhoto" alt="Portada de Torneo" class="img-fluid mb-2 d-block" />
                <button @click.prevent="removeCoverFile" class="btn btn-danger">Eliminar portada</button>
              </div>
              <FilePond
                name="fileCover"
                :maxFileSize="'2MB'"
                :accepted-file-types="supportedFormats" 
                allow-multiple="false"
                :max-files="1"
                label-idle="Arrastra tu imagen o <span class='filepond--label-action'>Buscar</span>"
                :labelMaxFileSizeExceeded="'El archivo es demasiado grande'"
                :labelMaxFileSize="'El tamaño máximo permitido es {filesize}'"
                :labelFileTypeNotAllowed="'El archivo tiene una extensión no permitida'" 
                :fileValidateTypeLabelExpectedTypes="`Los tipos de archivo permitidos son: ${supportedFormats.join(', ')}`"
                credits = ""
                @updatefiles="handleUpdateFiles"
                @input="clearError('fileCover')"
                v-if="!play.urlCoverPhoto"
              />
              <div class="input-error">{{ errors.fileCover }}</div>
            </div>
          </div>
          <div class="col-lg-12">
            <div class="d-flex flex-wrap gap-3">

              <RouterLink to="/plays" > 
                <button type="button" class="btn btn-danger bg-danger bg-opacity-10 text-danger border-0 fw-semibold py-2 px-4" >
                  Cancelar
                </button>
              </RouterLink>
              <button class="btn btn-primary bg-primary bg-opacity-10 text-primary border-0 fw-semibold py-2 px-4" type="submit" :disabled="isLoading" >
                  <span v-if="!isLoading">{{play.id == 0 ? 'Crear Jugada' : 'Actualizar Jugada'}}</span>
                  <span class="spinner-border spinner-border-sm me-2" aria-hidden="true" v-if="isLoading"></span>
                  <span role="status" v-if="isLoading">Procesando...</span>
              </button>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script lang="ts">
import { playSchema } from "@/schemas/playSchema";
import { defineComponent, ref, onMounted } from "vue";
import api from '@/services/api';
import { useToast } from "vue-toastification";
import { useRouter, useRoute } from 'vue-router'
import moment from 'moment'; 
  
import vueFilePond from "vue-filepond";
import FilePondPluginFileValidateType from "filepond-plugin-file-validate-type" ;
import FilePondPluginFileValidateSize from 'filepond-plugin-file-validate-size';
import FilePondPluginImagePreview from "filepond-plugin-image-preview";
import '@vuepic/vue-datepicker/dist/main.css';

import "filepond/dist/filepond.min.css";
import "filepond-plugin-image-preview/dist/filepond-plugin-image-preview.min.css"; 
import { es } from 'date-fns/locale';

// Create FilePond component
const FilePond = vueFilePond(
  FilePondPluginFileValidateType,
  FilePondPluginFileValidateSize,
  FilePondPluginImagePreview
);

export default defineComponent({
  name: "CreatePlay",
  components: {FilePond},

  setup() {
    const toast = useToast();
    const route = useRoute();
    const router = useRouter()
    const isLoading = ref(false);

    const itemsTournament = ref<any[]>([]);
    const itemsMatch = ref<any[]>([]);
    const play = ref({
        id: 0,
				name:'',
				tournamentId: null,
        matchId:null,
        startDate: null,
        endDate: null,
        title: null,
        subtitle: null,
        description: null,
        fileCover: null,
        urlCoverPhoto: null,
        kickoffTitle: null,
        kickoffDescription: null
		}); 
    const errors = ref<Record<string, string>>({});

    const supportedFormats = ['image/jpg', 'image/jpeg', 'image/png'];

    onMounted(async () => {
      await getTournaments();
      var idPlay = route.params.id;
      if(idPlay){
        await getPlayById(idPlay);
      }
    });

    const getTournaments = async() => {
      try {
        var params = `pageNumber=1&pageSize=99999&isActive=true`;
          
        const response = await api.get(`/tournament?${params}`);
        
        itemsTournament.value = response.data.list; 
      } catch (error) {
        console.error(error);
      } 
    };

    const getMatchesByTournament = async() => {
      try {
        var params = `pageNumber=1&pageSize=99999&isActive=true`;
        
        if(play.value.tournamentId){
          params  = params + `&tournamentId=${play.value.tournamentId}`
        }

        const response = await api.get(`/match?${params}`);
        
        itemsMatch.value = response.data.list; 
      } catch (error) {
        console.error(error);
      } 
    };

    const handleUpdateFiles = (fileItems: any[]) => {
      play.value.fileCover = fileItems.length ? fileItems[0].file : null;
    };

    const validateForm = async () => {
    
      try {
        errors.value = {};
        await playSchema.validate(play.value, { abortEarly: false });
        isLoading.value = true;
        
        await createPlay();
        isLoading.value = false;
      } catch (err: any) {
        console.log("err: " +err)
        if (err.inner) {
          err.inner.forEach((e: any) => {
            errors.value[e.path] = e.message;
          });
        }
        isLoading.value = false
      }
    };

    const clearError = (field: string) => {
      errors.value[field] = '';
    };
    
    const buildFormData = (data: any) => {
      const formData = new FormData();
      for (const key in data) {
        if (data[key] !== undefined && data[key] !== null && key != 'createdBy' ) {
          formData.append(key, data[key]);
        }
      }
      return formData;
    };

    const getPlayById = async(id:any) => {
        try {
          const response = await api.get(`/play/${id}`);
          const responseFormat = response.data;
          responseFormat.startDate =  moment(responseFormat.startDate).format('YYYY-MM-DD HH:mm');
          responseFormat.endDate =  moment(responseFormat.endDate).format('YYYY-MM-DD HH:mm');

          if (responseFormat.urlCoverPhoto) {
            responseFormat.urlCoverPhoto = process.env.VUE_APP_API_URL + '/' + responseFormat.urlCoverPhoto;
          }

          await getMatchesByTournament();


          play.value = responseFormat;
        
          
        }catch(ex){
          console.error(ex);
        }
    };

    const createPlay = async() => {
        try {
          const payload = {
            ...play.value,
            startDate: moment(play.value.startDate).toISOString(),
            endDate: moment(play.value.endDate).toISOString(),
          };

          const formData = buildFormData(payload);

          const response: any = await api.postForm(`/play`, formData);

          if(response.data.return){
            toast.success(`La Jugada fue ${play.value.id == 0 ? "creada" : "actualizada"} con éxito.`, {
              timeout: 2000
            });

            router.push({name: "PlaysPage"})
          }

        }catch(ex){
          toast.error("La Jugada no pudo ser creada.", {
            timeout: 2000
          });
          console.error(ex);
        }
    };

    const removeCoverFile = async() => {
      play.value.urlCoverPhoto = null
    }

    return {
      handleUpdateFiles,
      createPlay,
      validateForm,
      clearError,
      removeCoverFile,
      getMatchesByTournament,
      play,
      itemsTournament,
      itemsMatch,
      errors,
      isLoading,
      es,
      supportedFormats,
      
    };
  }
});
</script>
